import { createReducer } from '@reduxjs/toolkit';
import { AISearchActionCreator } from './actions';

const initialState = {
  data: [],
    filters: null,
    message: null,
    pending: false,
    error: null,
};

export const AISearchReducer = createReducer(initialState, (builder) => {
  builder
      .addCase(AISearchActionCreator.fetchAISearchResults.pending, (state) => {
        state.pending = true;
        state.error = null;
      })
      .addCase(AISearchActionCreator.fetchAISearchResults.fulfilled, (state, action) => {
        state.pending = false;
        state.data = action.payload.data;
        state.filters = action.payload.filters;
        state.message = action.payload.message;
      })
      .addCase(AISearchActionCreator.fetchAISearchResults.rejected, (state, action) => {
        state.pending = false;
        state.error = action.payload || 'Ошибка при поиске';
      });
});
